import React, { FC } from "react";
import { PlayerVM } from "../types";
import { BOT_BG, BOT_BORDER, getBadgeColors } from "../colors";

type Props = {
  homeSorted: PlayerVM[];
  awaySorted: PlayerVM[];
  badgeValue: (p: PlayerVM) => string;
  isBadgeEmpty: (p: PlayerVM) => boolean;
};

const DualView: FC<Props> = ({
  homeSorted,
  awaySorted,
  badgeValue,
  isBadgeEmpty,
}) => (
  <div className="grid grid-cols-[1fr_2vw_1fr] gap-[3vw]">
    <div className="flex flex-col gap-[1vw]">
      {homeSorted.map((p, idx) => {
        const empty = isBadgeEmpty(p);
        const colors = empty
          ? { bg: BOT_BG, border: BOT_BORDER }
          : getBadgeColors(homeSorted.length, idx);
        return (
          <div
            key={p.id}
            className="grid grid-cols-[1fr_auto] items-center gap-[2vw] py-[1.5vw]"
          >
            <div className="text-right text-[3vw]">
              <span className="block truncate">{p.name}</span>
            </div>
            <span
              className="inline-flex h-[4.5vw] min-w-[10vw] max-w-[10vw] items-center justify-center rounded-[1vw] border px-[2vw] text-center text-[3vw] font-extrabold"
              style={{
                backgroundColor: colors.bg,
                borderColor: colors.border,
                color: "#fff",
              }}
            >
              {badgeValue(p)}
            </span>
          </div>
        );
      })}
    </div>
    <div
      className="w-px justify-self-center"
      style={{ background: BOT_BORDER }}
    />
    <div className="flex flex-col gap-[1.5vw]">
      {awaySorted.map((p, idx) => {
        const empty = isBadgeEmpty(p);
        const colors = empty
          ? { bg: BOT_BG, border: BOT_BORDER }
          : getBadgeColors(awaySorted.length, idx);
        return (
          <div
            key={p.id}
            className="grid grid-cols-[auto_1fr] items-center gap-[2vw] py-[1.5vw]"
          >
            <span
              className="inline-flex h-[4.5vw] min-w-[10vw] max-w-[10vw] items-center justify-center rounded-[1vw] border px-[2vw] text-center text-[3vw] font-extrabold"
              style={{
                backgroundColor: colors.bg,
                borderColor: colors.border,
                color: "#fff",
              }}
            >
              {badgeValue(p)}
            </span>
            <div className="text-left text-[3vw]">
              <span className="block truncate">{p.name}</span>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default DualView;
